
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/why-whatsapp-for-business-ebook",
      function () {
        return require("private-next-pages/resources/why-whatsapp-for-business-ebook.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/why-whatsapp-for-business-ebook"])
      });
    }
  